function AutoFilterFormRangeLayout ( props ) {

    const { children } = props;

    return (
        <div>
        { children }
        </div>
    );

}

export default AutoFilterFormRangeLayout;

